import React from 'react'

const PricingView = () => {
  return (
    <div>PricingView</div>
  )
}

export default PricingView